import { render, staticRenderFns } from "./subTabs.vue?vue&type=template&id=88d454a4&"
import script from "./subTabs.vue?vue&type=script&lang=js&"
export * from "./subTabs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports